import { useAppStore } from '@/hud-bridge/store'

export function MenuScreen() {
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div className="screen">
      <div className="menu-enter" style={{ marginTop: '12vh', maxWidth: 520 }}>
        <h1 className="brand">3D Minesweeper</h1>
        <p className="slogan">Разминируй. Выйди.</p>
        <div className="btn-row">
          <button type="button" className="btn btn-primary" onClick={() => setScreen('mode')}>
            Play
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('records')}>
            Records
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('settings')}>
            Settings
          </button>
        </div>
      </div>
    </div>
  )
}
